<script setup>
// Google reCAPCHA　設定ページ (v2で設定してください)
// https://www.google.com/recaptcha/about/

import { inject, onMounted, onUnmounted } from 'vue';

const emit = defineEmits(['verify', 'expired', 'error', 'loaded']);

// サイトキー取得
const siteKey = inject('recaptchaSiteKey');

// greCaptchaリソースタグのID名
const recaptchaSrcId = 'recaptcha-src';

// 確認成功
const onVerify = response => {
    // console.log('onVerify called', response);
    emit('verify', String(response));
};

// 有効期限切れ
const onExpired = () => {
    // console.log('onExpired called');
    emit('expired');
};

// エラー
const onError = () => {
    alert('通信エラーが発生しました。\n時間を置いてページを再読み込みしてください')
    // console.log('onError called');
    emit('error');
};

const onLoaded = () => {
    // greCaptchaが読み込まれたら、動的に描画する（SPAの場合は動的描画が必要）
    grecaptcha.render(document.getElementById('recaptcha'), {
        'sitekey': siteKey,
        'callback': onVerify,
        'expired-callback': onExpired,
        'error-callback': onError,
    });

    emit('loaded');
};

onMounted(() => {
    const wind = window;
    wind.onVerify = onVerify;
    wind.onExpired = onExpired;
    wind.onError = onError;
    wind.onLoad = onLoaded;

    // コンポーネントを使っている間だけgreCaptchaを読み込む
    if (!document.getElementById(recaptchaSrcId)) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=onLoad&render=explicit');
        script.setAttribute('async', '');
        script.setAttribute('defer', '');
        script.setAttribute('id', recaptchaSrcId);
        document.head.appendChild(script);
    }
});

onUnmounted(() => {
    const wind = window;
    wind.onVerify = null;
    wind.onExpired = null;
    wind.onError = null;
    wind.onLoad = null;

    // コンポーネントが不要になったら読み込んでいたgreCaptchaを削除する
    const script = document.getElementById(recaptchaSrcId);
    if (script) {
        script.parentNode.removeChild(script);
    }
});

</script>
<template>
    <div id="recaptcha" class="g-recaptcha" style="text-align: -webkit-center"></div>
</template>
